import * as React from 'react';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { stringIsNullOrEmpty } from '../Common/Utilities';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export class InvoiceDocumentRoutingHistory extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: [],
			dataloaded: false
		};

		this.inProgress = false;

		this.close_clickHandler = this.close_clickHandler.bind(this);
	}

	componentDidUpdate() {
		var that = this;

		if (this.props.info.openDialog && !this.state.dataloaded && !this.inProgress) {
			this.inProgress = true;
			this.props.info.inProgress(true);
			this.fetchInvoiceDocumentRoutingHistory();
		}
	}

	fetchInvoiceDocumentRoutingHistory() {
		const { rowData, routingHistoryData } = this.props.info;
		const invoiceDocumentId = rowData?.invoiceDocumentId || routingHistoryData?.invoiceDocumentId;
		const seqId = routingHistoryData?.seqId || "";

		if (!invoiceDocumentId) {
			this.props.info.inProgress(false);
			return;
		}

		httpGet(`/api/invoicedocument/invoicedocumentroutinghistory/${invoiceDocumentId}/${seqId}`)

			.then((response) => {
				this.inProgress = false;
				this.setState({ data: response.data, dataloaded: true });
				this.props.info.inProgress(false);
			})
			.catch((error) => {
				this.inProgress = false;
				this.props.info.inProgress(false);
				this.setState({ dataloaded: true });
				toast.error('An error occurred while fetching the records');
			});
	}

	close_clickHandler(event) {
		this.setState({ data: [], dataloaded: false });
		this.inProgress = false;
		if (this.props.onClose) {
			this.props.onClose(event, this.state.rowData);
		}
	}

	render() {
		const { routingHistoryData } = this.props.info;
		const dialogTitle = routingHistoryData?.historyTitle || "Invoice Document Approval History";
		return (
			<Dialog open={this.props.info.openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
				<DialogTitle>
					{dialogTitle}
				</DialogTitle>
				<DialogContent>
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							
							columns={[
								{
									headerName: 'Approval Level',
									field: 'approvalLevel',
									flex:1
								},
								{
									headerName: 'Status',
									field: 'status',
									flex: 1
								},
								{
									headerName: 'Comments',
									field: 'approvalRejectionComment',
									flex: 1
								},
								{
									headerName: 'Timestamp',
									field: 'timestamp',
									flex: 1
								},
								{
									headerName: 'User',
									field: 'resourceName',
									flex: 1,
									valueGetter: ({ value }) => {
										if (value && value.indexOf(',') !== -1) {
											let _v = value.split(',');
											if (_v.length === 2) {
												let ln = _v[0]?.replaceAll(' ', '');
												if (stringIsNullOrEmpty(ln)) {
													value = _v[1]?.trim() || '';
												}
											}
										}
										return value;
									}
								}
								
							]}
							options={{
								toolbar: false,
								sorting: false,
								draggable: false,
								pageSize: 10,
								pageSizeOptions: [10, 20, 30, 40, 50],
								maxBodyHeight: 350
							}}
							getRowId={(row) => row.sequenceId}
							disableSelectionOnClick
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={this.close_clickHandler} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
